var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgActionPanel = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 76,
    viewBox: "0 0 211 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.85176e-06 33.6366C-1.03974e-06 52.2136 15.1426 67.2732 33.822 67.2732L98.9098 67.2732L105.28 75.8094C105.594 76.2296 106.547 75.824 106.547 75.824L113.243 67.2732L177.178 67.2732C195.857 67.2732 211 52.2136 211 33.6366C211 15.0596 195.857 6.69759e-06 177.178 7.51409e-06L33.822 6.15099e-06C15.1426 6.96749e-06 -2.66379e-06 15.0596 -1.85176e-06 33.6366Z",
    fill: "#F1F2F4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.7113 66.6751L99.4113 66.2732L98.9098 66.2732L33.822 66.2732C15.6897 66.2732 0.999999 51.6561 0.999998 33.6366C0.999997 15.6171 15.6897 1.00001 33.822 1.00001L177.178 1.00001C195.31 1.00001 210 15.6171 210 33.6366C210 51.6561 195.31 66.2732 177.178 66.2732L113.243 66.2732L112.756 66.2732L112.456 66.6566L105.945 74.9707C105.933 74.9737 105.921 74.9766 105.908 74.9793L99.7113 66.6751ZM106.16 74.9019C106.161 74.9016 106.161 74.9017 106.16 74.902L106.16 74.9019Z",
    stroke: "#D5D8DD",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 0,
    width: 211,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActionPanel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ActionPanel.4249b540d7e0f44144ac79dc825f29e0.svg";